const DECIMAL_ID = /^[1-9][0-9]*$/;

const readTenantIds = (): ReadonlySet<string> | null => {
  const raw =
    typeof window !== 'undefined'
      ? (window.config as unknown as { websiteTrafficQualityTenantIds?: unknown } | undefined)
          ?.websiteTrafficQualityTenantIds
      : undefined;
  if (!Array.isArray(raw) || raw.length === 0) return null;
  const ids = new Set<string>();
  for (const entry of raw) {
    if (typeof entry !== 'string' || !DECIMAL_ID.test(entry) || !Number.isSafeInteger(Number(entry))) return null;
    if (ids.has(entry)) return null;
    ids.add(entry);
  }
  return ids;
};

/**
 * Whether the brand tenant is on the website traffic quality rollout list, `window.config.websiteTrafficQualityTenantIds`
 * (an array of unique positive decimal tenant ID strings), read on each call. Fails closed: a missing tenant, a missing,
 * empty, wrongly typed or invalid list refuses every tenant, and nothing in local storage or the address can override
 * it. Takes the brand's `tenant_id`, never `window.config.clientId`.
 */
export const isWebsiteTrafficQualityTenantAllowed = (tenantId: number | undefined): boolean => {
  if (tenantId === undefined || !Number.isSafeInteger(tenantId) || tenantId <= 0) return false;
  return readTenantIds()?.has(String(tenantId)) ?? false;
};
